import { combineReducers } from 'redux';
import fetch from '../components/Fetch';
import { screen } from './screen';

const appReducer = combineReducers({
  fetch,
  screen,
});

export default (state, action) => appReducer(state, action);
